import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import InvestmentFocus from "../components/InvestmentFocus";
import StructuredCapital from "../components/StructuredCapital";
import StatsSection from "../components/StatsSection";
import StrategyCTA from "../components/StrategyCTA";

import Insights from "../components/Insights";
import ConnectCTA from "../components/ConnectCTA";
import Footer from "../components/Footer";

export default function HomePage() {
  return (
    <div data-testid="homepage" className="min-h-screen bg-slate-50" style={{ scrollBehavior: 'smooth' }}>
      <Navbar />
      <main>
        <HeroSection />
        <InvestmentFocus />
        <StructuredCapital />
        <StatsSection />
        <StrategyCTA />
        <Insights />
        <ConnectCTA />
      </main>
      <Footer />
    </div>
  );
}
